import { Fragment, ReactElement } from 'react';

import {
  Avatar,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { formatDateForLocale } from '@/utils';

import { Ticket } from '../types';

export const TicketsTableRow = (props: Ticket): ReactElement => {
  const formattedSchedule = formatDateForLocale(props.schedule);

  return (
    <Fragment>
      <TableRow>
        {/* ID */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            #{props.id}
          </Typography>
        </TableCell>

        {/* Full name */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            <Stack direction="row" alignItems="center" gap={1} fontSize={12}>
              <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>
              {props.ticket}
            </Stack>
          </Typography>
        </TableCell>

        {/* Events */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.price}
          </Typography>
        </TableCell>

        {/* Email */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            <Stack direction="row" gap={1}>
              <Stack gap={1} alignItems="center">
                <Typography fontSize={12} color="gray500">
                  Taken
                </Typography>
                <Typography fontSize={12}>{props.seats}</Typography>
              </Stack>
              <Stack borderLeft="1px solid #1F243199"></Stack>
              <Stack gap={1} alignItems="center">
                <Typography fontSize={12} color="gray500">
                  Max Seats
                </Typography>
                <Typography fontSize={12}>{props.seats}</Typography>
              </Stack>
            </Stack>
          </Typography>
        </TableCell>

        {/* Last Active Date */}
        <TableCell>{formattedSchedule}</TableCell>

        {/* Status */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.status}
          </Typography>
        </TableCell>

        {/* Action button(s) */}
        <TableCell>
          <Stack direction="row" spacing={0.5}>
            <IconButton aria-label="Action Button" size="small" color="inherit">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
            <IconButton aria-label="View Button" size="small" color="inherit">
              <RemoveRedEyeOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};
